<template>
    <div class="wrap ordering-codes">
        <!-- <div class="title">
            <h2>同步绑定</h2>
        </div> -->
        <div class="inner-box">
            <div>
                <!-- <el-button @click="changeTab('all')" type="success" size="medium">点餐码解析</el-button> -->
                <el-button @click="changeTab('not')" :type="tabValue == 'not' ? 'success' : 'primary'"
                    size="medium">未审核</el-button>
                <el-button @click="changeTab('ed')" :type="tabValue == 'ed' ? 'success' : 'primary'" size="medium"
                    style="margin-left: 10px;">已审核</el-button>
            </div>
            <div class="mt20 select-box">
                <div>
                    <el-input placeholder="请输入主体名称" class="w200 seekIpt" v-model="search.entityName"
                        @keyup.enter.native="searchTableData">
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="searchTableData"></i>
                    </el-input>
                    <el-input placeholder="请输入点餐桌号" class="ml20 w200 seekIpt" v-model="search.tableNum"
                        @keyup.enter.native="searchTableData">
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="searchTableData"></i>
                    </el-input>
                    <el-cascader class="ml20 w200" v-model="search.areaId" :options="areaList.options" @change="areaChange"
                        :props="areaList.props" clearable placeholder="所属行政区" ref="cascader"></el-cascader>
                    <el-select v-if="tabValue == 'ed'" class="ml20 w200" v-model="search.usabilityValue"
                        @change="searchTableData" collapse-tags placeholder="可用性">
                        <el-option v-for="item in usabilityList" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </div>
                <!-- <div v-if="tabValue == 'ed'">
                    <el-button style="float:right" :disabled='isDisabled' @click="batchExport" type="primary"
                        size="medium">批量导出公示二维码</el-button>
                </div> -->
            </div>
            <!-- 表格 -->
            <div style="margin-top: 10px;">
                <el-table ref="table" :data="tableData" @selection-change="handleSelectionChange" @sort-change="sortChange"
                    border style="width: calc(100% - 10px);" :cell-style="{ 'text-align': 'center' }"
                    :header-cell-style="{ 'text-align': 'center' }" v-loading="tableLoading">
                    <el-table-column type="selection" :selectable="selectableFunc" width="55" :key="1"
                        v-if="tabValue == 'ed'"></el-table-column>
                    <el-table-column :key="2" type="index" label="序号" width="80"></el-table-column>
                    <el-table-column :key="3" prop="entityName" label="主体名称" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ scope.row.entityName ? scope.row.entityName : '-' }}
                        </template>
                    </el-table-column>
                    <el-table-column :key="4" prop="areaName" label="所属行政区" min-width="150" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ scope.row.areaName ? scope.row.areaName : '-' }}
                        </template>
                    </el-table-column>
                    <el-table-column sortable="custom" prop="uploadTime" :key="5" label="上传时间" min-width="100"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ scope.row.uploadTime ? scope.row.uploadTime : '-' }}
                        </template>
                    </el-table-column>
                    <el-table-column :key="6" prop="deskNo" label="点餐码桌号" min-width="100" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ scope.row.deskNo ? scope.row.deskNo : '-' }}
                        </template>
                    </el-table-column>
                    <el-table-column :key="7" v-if="tabValue == 'ed'" prop="availableOrNot" label="可用性" min-width="100"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ scope.row.availableOrNot == 'PASS' ? '可用' : '不可用' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="name" label="链接地址" :key="8" min-width="160">
                        <template slot-scope="scope">
                            <span v-if="scope.row.linkUrl" class="text-column">
                                <el-tooltip class="item" effect="dark" :content="scope.row.linkUrl" placement="top">
                                    <span class="text-overflow">
                                        {{ scope.row.linkUrl }}
                                    </span>
                                </el-tooltip>
                                <i class="el-icon-copy-document" style="cursor:pointer;color:#409eff"
                                    @click="copy(scope.row.linkUrl)"></i>
                            </span>
                            <span v-else></span>
                        </template>
                    </el-table-column>
                    <el-table-column :key="9" prop="businessQrCode" label="商家二维码" min-width="100">
                        <template slot-scope="scope">
                            <el-image v-if="scope.row.businessQrCode" style="width: 40px;height:40px"
                                :src="scope.row.businessQrCode" :preview-src-list="[scope.row.businessQrCode]">
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column :key="10" v-if="tabValue == 'ed'" prop="name" label="生成二维码" min-width="100"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-image v-if="scope.row.platformQrCode" style="width: 40px;height:40px"
                                :src="scope.row.platformQrCode" :preview-src-list="[scope.row.platformQrCode]">
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column :key="11" fixed="right" label="操作" min-width="220">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.availableOrNot == 'NOPASS' || tabValue == 'not'"
                                @click="analysis(scope.row)" type="success" plain size="small">修改链接</el-button>
                            <el-button v-if="scope.row.availableOrNot == 'NOPASS' || tabValue == 'not'"
                                @click="pass(scope.row, 'yes')" type="primary" plain size="small">可用</el-button>
                            <el-button v-if="tabValue == 'not'" @click="pass(scope.row, 'no')" type="danger" plain
                                size="small">不可用</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <ybPagination :page="page" @size-change="pageSizeChange" @current-change="pageCurrentChange"
                style="margin-top:10px; margin-right:10px"></ybPagination>
        </div>

        <!-- 弹窗 -->
        <el-dialog class="dialogDiv" :close-on-click-modal="false" :modal-append-to-body='false' :title="dialogTitle"
            :visible.sync="linkDialogVisible" :before-close="closeDialog">
            <el-form :model="linkData" :rules="dataRules" ref="linkData" class="ml20 mr20" label-position="right"
                label-width="100px">
                <el-form-item label="链接地址" prop="link">
                    <el-input v-model="linkData.link" placeholder="请输入链接地址"></el-input>
                </el-form-item>
            </el-form>
            <div class="footer">
                <el-button @click="closeDialog" round>关闭</el-button>
                <el-button type="primary" :loading="btnLoading" @click="submit('linkData')" round>确定</el-button>
            </div>
        </el-dialog>

        <el-dialog class="dialogDiv" :close-on-click-modal="false" :modal-append-to-body='false' :title="dialogTitle"
            :visible.sync="erweimaDialog" :before-close="closeDialog">
            <div class="erweima-box">
                <img :src="qrcodeImg" @error='imgOnError' alt="">
                <p>请最后微信扫描该二维码验证是否能够直接跳转点餐页面</p>
            </div>
            <div class="footer">
                <el-button @click="closeDialog" round>取消</el-button>
                <el-button type="primary" :loading="btnLoading" @click="statusSubmit" round>验证通过</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import * as subManageApi from '@/api/subManage'
import * as orderingCodesApi from '@/api/orderingCodes'
import ybPagination from '@/components/ybPagination'
import axios from "axios";

export default {
    name: 'orderingCodes',
    components: {
        ybPagination,
    },
    data() {
        return {
            dialogTitle: '修改链接',
            linkDialogVisible: false,
            erweimaDialog: false,
            btnLoading: false,
            messageShow: false,
            linkData: {
                link: '',
            },
            tabValue: 'not',
            usabilityList: [
                { label: '全部', value: '' },
                { label: '可用', value: 'PASS' },
                { label: '不可用', value: 'NOPASS' },
            ],
            parentId: '0',
            search: {
                areaId: '',
                entityName: '',
                tableNum: '',
                usabilityValue: '',
            },
            dataRules: {
                link: [
                    { required: true, message: '请输入链接地址', trigger: 'blur' }
                ],
            },
            rowId: '',
            qrcodeImg: '',
            areaList: {
                selectedOptions: [],
                options: [],
                parentCode: '',
                props: {
                    checkStrictly: true,
                    expandTrigger: 'hover',
                    value: 'areaId',
                    label: 'areaName',
                    children: 'children',
                    lazy: true,
                    lazyLoad(node, resolve) { }
                }
            },
            idArr: [],
            tableLoading: false,
            tableData: [],
            page: {
                pageSize: 10,
                pageNum: 1,
                total: 10
            },
        }
    },
    beforeUpdate() {
        this.$refs.table.doLayout()
    },
    computed: {
        isDisabled: function () {
            return this.idArr.length ? false : true
        },
    },
    created() {
        let that = this;
        that.areaList.props.lazyLoad = function (node, resolve) {
            let code = node.value ? node.value : that.parentId;
            if (code.length > 6) {
                return resolve([])
            }
            subManageApi.getAreaList({ parentId: code }).then(r => {
                if (r.code === 200) {
                    resolve(r.data)
                }
            });
        }
        this.getTableData()
    },
    methods: {
        searchTableData() {
            this.page.pageNum = 1
            this.getTableData()
        },
        selectableFunc(row, index) {
            if (row.availableOrNot == 'PASS') {
                return true //可选择
            } else {
                return false; //不可选择
            }
        },
        // 批量导出
        batchExport() {
            this.$confirm('是否确定批量导出主体公示二维码?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                orderingCodesApi.exportQrcode({ idList: this.idArr }).then(r => {
                    if (r.code == 200) {
                        window.open(r.data)
                        this.$message.success('下载成功')
                    } else {
                        this.$message.warning(r.massage)
                    }
                })
            })
        },
        // 多选
        handleSelectionChange(val) {
            let arr = []
            this.idArr = []
            val.forEach(item => {
                arr.push(item.id)
            })
            this.idArr = arr
        },
        // 提交
        submit(refValue) {
            this.$refs[refValue].validate((valid) => {
                if (valid) {
                    this.btnLoading = true
                    let params = {
                        id: this.rowId,
                        linkUrl: this.linkData.link
                    }
                    orderingCodesApi.UpdateReviewLink(params).then(r => {
                        this.btnLoading = false
                        if (r.code == 200) {
                            this.$message.success('操作成功')
                            this.closeDialog()
                            this.getTableData()
                        } else {
                            this.$message.warning(r.massage)
                        }
                    })
                }
            })
        },
        // 改变状态为可用提交
        statusSubmit() {
            this.btnLoading = true
            let params = {
                status: 'PASS',
                id: this.rowId
            }
            orderingCodesApi.UpdateReviewStatus(params).then(r => {
                this.btnLoading = false
                if (r.code == 200) {
                    this.$message.success('操作成功')
                }
                this.getTableData()
                this.closeDialog()
            })
        },
        // 复制
        copy(value) {
            let oInput = document.createElement("input"); // 创建输入框元素
            oInput.value = value; // 将想要复制的值赋值给输入框
            document.body.appendChild(oInput); // 在页面上追加输入框
            oInput.select(); // 选中输入框
            document.execCommand("Copy"); // 执行浏览器复制命令
            oInput.remove(); // 移除输入框
            this.$message.success('复制成功')
        },
        // 关闭弹窗
        closeDialog() {
            if (this.$refs.linkData !== undefined) {
                this.$nextTick(() => {
                    this.$refs.linkData.resetFields();
                })
            }
            this.linkDialogVisible = false
            this.erweimaDialog = false
        },
        // 排序
        sortChange(column) {
            if (column.order == 'ascending') {
                this.search.sort = 'asc';
            } else if (column.order == 'descending') {
                this.search.sort = 'desc'
            } else {
                this.search.sort = ''
            }
            this.getTableData()
        },
        // 修改链接
        analysis(row) {
            this.linkData.link = row.linkUrl
            this.rowId = row.id
            this.linkDialogVisible = true
            this.dialogTitle = '修改链接'
        },
        // 图片加载错误
        imgOnError() {
            // var that = this
            // axios.get(this.qrcodeImg).then(function (r) {
            //     that.$message.warning(r.data.msg)
            //     that.closeDialog()
            // })
        },
        // 通过
        pass(row, type) {
            this.rowId = row.id
            if (type == 'yes') {//可用
                if (row.linkUrl) {
                    this.tableLoading = true
                    orderingCodesApi.getAvailable({id:this.rowId}).then(r=>{
                        this.tableLoading = false
                        if(r.code == 200){
                            this.qrcodeImg = r.data
                            this.erweimaDialog = true
                        }else{
                            this.$message.warning(r.msg)
                        }
                    })
                } else {
                    this.$message.warning('请输入链接地址')
                }
            } else {//不可用
                this.$confirm('该点餐码是否为不可用?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {
                        status: 'NOPASS',
                        id: row.id
                    }
                    orderingCodesApi.UpdateReviewStatus(params).then(r => {
                        if (r.code == 200) {
                            this.$message.success('操作成功')
                            this.getTableData()
                        } else {
                            this.$message.warning(r.massage)
                        }
                    })
                })
            }
        },
        // 获取数据
        getTableData() {
            this.tableLoading = true
            let params = {
                "areaCode": this.search.areaId,
                "auditStatus": this.tabValue == 'ed' ? 'WAITED' : 'WAITING',
                "availableOrNot": this.search.usabilityValue,
                "current": this.page.pageNum,
                "deskNo": this.search.tableNum,
                "entityName": this.search.entityName,
                "size": this.page.pageSize,
                "orderBy": this.search.sort
            }
            orderingCodesApi.getReviewPage(params).then(r => {
                this.tableLoading = false
                this.tableData = r.data.records
                this.page.total = r.data.total
            })
        },
        //切换tab
        changeTab(val) {
            if (val == this.tabValue) {
                return
            }
            for (let i of this.tableData) {
                this.$refs.table.toggleRowSelection(i, false);
            }
            this.tabValue = val
            this.page.pageNum = 1
            this.idArr = []
            this.search.areaId = ''
            this.search.usabilityValue = ''
            this.search.tableNum = ''
            this.search.entityName = ''
            this.search.sort = ''
            this.getTableData()
        },
        // 点击区域节点前的圆圈进行选择
        areaChange(val) {
            this.page.pageNum = 1
            this.search.areaId = val[val.length - 1]
            this.getTableData();
        },
        // 页数改变
        pageCurrentChange(num) {
            if (num !== this.page.pageNum) {
                this.page.pageNum = num;
                this.getTableData();
            }
        },
        // 页数据量改变
        pageSizeChange(size) {
            if (size !== this.page.pageSize) {
                this.page.pageSize = size;
                this.getTableData();
            }
        }
    }
}
</script>
<style lang='scss' scoped>
.wrap {
    width: 100%;
    height: calc(100% - 40px);
    text-align: left;

    .select-box {
        display: flex;
        justify-content: space-between;
    }

    .text-column {
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: 100%;
        width: 100%;
    }

    .text-overflow {
        display: inline-block;
        width: 80%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .footer {
        margin-top: 20px;
        text-align: right;
    }

    .erweima-box {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        img {
            width: 120px;
            height: 120px;
            margin-bottom: 30px;
        }
    }
}
</style>